module.exports = __webpack_public_path__ + "img/8c1c8d5.png";